import { IS_EMAIL } from '../regexRules';
import { Validated } from '../Validator';

export default function isEmail<TError>(
    value: string,
    error: TError,
): Validated<string, TError> {
    return (
        !IS_EMAIL.test(value)
            ? {
                isValid: false,
                error,
            }
            : {
                isValid: true,
                value,
            }
    );
}

